import React from 'react';
export default function LetUsHelpYouSection(props) {
    const { isSelected, goToStayInTouch, isMobile, isTraditional } = props;
    return <div role='group' className={isMobile ? 'help-container mobile' : 'help-container desktop'} id={isTraditional ? 'traditional' : ""}>
        {isSelected ? <span className='help-text'>Unsure about your selection?</span>
            :
            <span className='help-text'>Don’t see what you’re looking for?</span>}
        <button className={isSelected || isTraditional ? 'help-button secondary' : 'help-button primary'} onClick={goToStayInTouch} aria-label="let us help you">Let us help you</button>
    </div>
}